import { ModelSagres } from "../../model-sagres";
import { ArquivoLicitacao } from "../arquivo-licitacao";

/**
 * Dados da aba de vencedores de uma licitação
 * @since 20230525
 */
export class LicitacaoHomologacao extends ModelSagres {
  IdLicitacao: number;
  DtAdjudicacao: Date;
  FlHomologParcial: string;
  DtHomologacao?: Date;
  ArquivoLicitacao?: ArquivoLicitacao[];
  NrLicitacao: number;
  NrAnoLicitacao: number;
  NumeroAnoLicitacao: string;

  ArquivoEdital?: any;
  ArquivoAta?: any;
  ArquivoParecer?: any;

  toFormData(): FormData {
    const data = new FormData();
    data.append("IdLicitacao", String(this.IdLicitacao));
    data.append("FlHomologParcial", this.FlHomologParcial);
    if (this.DtAdjudicacao)
      data.append("DtAdjudicacao", this.DtAdjudicacao.toISOString());
    if (this.DtHomologacao)
      data.append("DtHomologacao", this.DtHomologacao.toISOString());
    if (this.ArquivoAta instanceof File) {
      data.append("ArquivoAta", this.ArquivoAta as unknown as Blob);
    }
    return data;
  }

  tratarDadosAPI(): void {
    if (this.NrLicitacao)
      this.NumeroAnoLicitacao = `${this.NrLicitacao}/${this.NrAnoLicitacao}`;

    if (this.DtAdjudicacao) {
      this.DtAdjudicacao = new Date(this.DtAdjudicacao);
    }
    if (this.DtHomologacao) {
      this.DtHomologacao = new Date(this.DtHomologacao);
    }
    if (this.ArquivoLicitacao) {
      const arqEdital = this.ArquivoLicitacao.find(x => x.IdTipoArquivo === 1)
      const arqAta = this.ArquivoLicitacao.find(x => x.IdTipoArquivo === 2)
      const arqParecer = this.ArquivoLicitacao.find(x => x.IdTipoArquivo === 3)
      if(arqEdital !== undefined) this.ArquivoEdital = Object.assign(new ArquivoLicitacao(), arqEdital);
      if(arqAta !== undefined) this.ArquivoAta = Object.assign(new ArquivoLicitacao(), arqAta);
      if(arqParecer !== undefined) this.ArquivoParecer = Object.assign(new ArquivoLicitacao(), arqParecer);
    }
  }

  getTipoArquivo(tipo) {
    if(tipo === 'edital') {
      if(this.ArquivoEdital instanceof File) return "naosalvo";
      if(this.ArquivoEdital instanceof ArquivoLicitacao) return "salvo";
    }
    else if(tipo === 'ata') {
      if(this.ArquivoAta instanceof File) return "naosalvo";
      if(this.ArquivoAta instanceof ArquivoLicitacao) return "salvo";
    }
    else if(tipo === 'parecer') {
      if(this.ArquivoParecer instanceof File) return "naosalvo";
      if(this.ArquivoParecer instanceof ArquivoLicitacao) return "salvo";
    }
    return null;
  }
}
